import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "cognito-logo-mark",
  "aria-label": "SlashExperts"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("span", {
      class: "cognito-logo-mark__slash",
      "aria-hidden": "true"
    }, "/", -1),
    _createElementVNode("span", { class: "cognito-logo-mark__word" }, "Experts", -1)
  ]))]))
}